module.exports = __webpack_public_path__ + "img/cz.57608305.png";